import React from 'react';
import { Notification, Card, Title } from "rbx";
import NotificationService from '../../../services/notification';
import { recipients } from '../../../commons/constants';
import { unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import useForm from '../../components/useForm';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '3px'
};

const NotificationsNewForm = ({ fetchNotifications }) => {
  const initialFormValues = {
    title: '',
    message: '',
    url: '',
    imageUrl: '',
    recipient: 'specific', //['all', 'app', 'pdv', 'specific', 'default']
    default_notification: 'bugFixed', //bugFixed
    cpf_cnpj: '',
    timer: ''
  }

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    try {
      const data = {
        ...values,
        cpf_cnpj: unMask(values.cpf_cnpj)
      }
      const response = await NotificationService.register(data);
      setStatus(['success', `${response.status}: ${response.data.message}`]);
      fetchNotifications();
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Title size={5} className="mb-4">
            Nova Notificação
          </Title>
          <hr style={ styleHr }/>
          <Controls.TextField 
            label="Título"
            name="title"
            placeholder='Título'
            value={values.title}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.TextareaField 
            label="Mensagem"
            name="message"
            placeholder='Escreva sua mensagem aqui!'
            value={values.message}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="URL"
            name="url"
            placeholder='https://subdominio.dominio.com/mais-alguma-coisa'
            value={values.url}
            onChange={handleInputChange}
          />
          <Controls.TextField 
            label="URL da Imagem"
            name="imageUrl"
            placeholder='https://subdominio.dominio.com/mais-alguma-coisa'
            value={values.imageUrl}
            onChange={handleInputChange}
          />
          <Controls.SelectField
            label="Quem irá receber?"
            name="recipient"
            value={values.recipient}
            onChange={handleInputChange}
            options={recipients}
            required
          />
          <Controls.TextField 
            label="Notificação padrão"
            name="default_notification"
            value={values.default_notification}
            onChange={handleInputChange}
            required
          />
          <Controls.CpfCnpjField 
            label="CPF ou CNPJ"
            name="cpf_cnpj"
            placeholder='123.456.789-01'
            value={values.cpf_cnpj}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Tempo de duração"
            name="timer"
            placeholder='* * * *'
            value={values.timer}
            onChange={handleInputChange}
            required
          />
          <Controls.ActionButton 
            buttonState={stateButton}
            buttonName='Registrar'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default NotificationsNewForm;

